import React, { Fragment, useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { WithApp } from 'contexts/appContext';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsFindBy } from 'services/WService';
import { currency } from 'hooks/Pipe';
import { Assignment } from '@material-ui/icons';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'ID Hoja', accessor: 'prog_sheet_distribution_id', width: 130  },
  { Header: 'Cod. Ruta', accessor: 'route_code', width: 130 },
  { Header: 'Ruta', accessor: 'route_description' },
  { Header: 'Mesa', accessor: 'bureau_description' },
  { Header: 'Monto total', accessor: 'total_amount', width: 150 },
  { Header: 'Total Ordenes', accessor: 'total_order', width: 150 },
  { Header: 'Total clientes', accessor: 'total_customer', width: 150  },
  { Header: 'Estado', accessor: 'state', width: 130 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ProgAnalysisShow(props) {
  const classes = useStyles();
  const { id } = useParams();
  const [notify] = useToasty();
  const [data, setData] = useState([]);

  async function listDatas() {
    let response = await wsFindBy('prog/program-analysis-detail', {prog_analysis_distribution_id: id});
    if (response.success) {
      setData(response.data);
    }
  }

  useEffect(() => {
    listDatas();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />
      <Card>
        <CardHeader icon>
          <CardIcon pointer="true" color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de rutas para análisis</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName={`Rutas para analisis`}
            formatDate="DD-MM-YYYY"
            defaultWidth={1500}
            columns={columns}
            data={data.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                    </div>
                  ),
                  route_code: item.route?.code,
                  route_description: item.route?.description,
                  bureau_code: item.bureau?.code,
                  bureau_description: item.bureau?.description,
                  prog_sheet_distribution_id: item.prog_sheet_distribution_id,
                  total_amount: currency(item.total_amount),
                  total_order: item.total_order,
                  total_customer: item.total_customer,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
});
